import { render, staticRenderFns } from "./CommonDialog.vue?vue&type=template&id=718ca4dd&scoped=true"
import script from "./CommonDialog.vue?vue&type=script&lang=js"
export * from "./CommonDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718ca4dd",
  null
  
)

export default component.exports